// extracted by mini-css-extract-plugin
module.exports = {"icon":"TaxonomyTestModal-module__icon___34gAd","error":"TaxonomyTestModal-module__error___75tRm","success":"TaxonomyTestModal-module__success___3bHls"};